import { configureStore } from '@reduxjs/toolkit';
import rightDrawerReducer from '../features/common/rightDrawerSlice';
import leftDrawerReducer from '../features/common/leftDrawerSlice';
import headerReducer from '../features/common/headerSlice';
import modalReducer from '../features/common/modalSlice';
import pastVisitsReducer from '../features/pastvisits/pastVisitsSlice';
import visitReducer from '../features/visits/visitSlice';
import authReducer from '../features/auth/authSlice'
import activeUserReducer from '../features/auth/activeUserSlice'
import supportChatReducer from '../features/supportChat/supportChatSlice'
import rxWriterReducer from '../features/rxWriter/rxWriterSlice';

export const store = configureStore({
  reducer: {
    header: headerReducer,
    modal: modalReducer,
    rightDrawer: rightDrawerReducer,
    leftDrawer: leftDrawerReducer,
    pastVisits: pastVisitsReducer,
    visits: visitReducer,
    auth: authReducer,
    activeUser: activeUserReducer,
    supportChat: supportChatReducer,
    rxWriter: rxWriterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore the openModal action
        ignoredActions: [
          'rightDrawer/openRightDrawer',
          'rightDrawer/closeRightDrawer',
          'rightDrawer/setDrawerTriggeredManually',
          'leftDrawer/openLeftDrawer',
          'leftDrawer/closeLeftDrawer',
          'leftDrawer/setLeftDrawerTriggeredManually',
          'modal/openModal',
          'visits/updateCurrentVisitForChat',
          'visits/setCurrentVisitId',
          'visits/setUnsubscribe',
          'visits/fetchVisitForChat/fulfilled',
          'rxWriter/setMedicationFormData',
         
        ],
        ignoredPaths: ['rightDrawer.extraObject', 'leftDrawer.extraObject', 'modal.extraObject', 'visits.unsubscribe', 'visits.currentVisitForChat'],
      },
    }),
});
